export const IS_VISIBLE_PRIVACY_POLICY = 'is_visible_privacy_policy';
